import {
  useRouteError,
  isRouteErrorResponse,
  Navigate,
} from "react-router-dom";
import { isAxiosError } from "axios";
import { queryClient } from "./queryClient";
import { userQuery } from "./auth";

export default function ErrorPage() {
  const error = useRouteError();

  if (isAxiosError(error) && error.response?.status === 401) {
    queryClient.invalidateQueries({ queryKey: userQuery().queryKey });
    return <Navigate to={"/auth/login"} replace />;
  }

  console.error(error);

  let errorMessage = "Unknown error message";
  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{errorMessage}</i>
      </p>
    </div>
  );
}
